<span class="badge rounded-pill text-bg-light ms-1"
      matTooltip="{{'kudos-card.private' | translate }}"
      matTooltipPosition="above">{{'kudos.private' | translate}}&nbsp;<i class="fa-solid fa-eye-slash"></i></span>
